var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"formLabel fl"},[(_vm.showIcon)?_c('span',{staticClass:"icon"},[_vm._v("*")]):_vm._e(),_c('span',{class:{ redColor: _vm.fontColor }},[_vm._v(_vm._s(_vm.label))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }